export const PaymentReminderPreviewChannelName = "PAYMENT_REMINDER_PREVIEW";

export interface PaymentReminderPreviewData {
  subject: string;
  greeting?: string;
  // Rich-text HTML; variable tokens stay literal (e.g. &lt;Invoice Number&gt;).
  body?: string;
  supplierLogoUrl?: string;
}

export interface PaymentReminderPreviewBroadcastChannel {
  // `reload` — the preview tab just opened/refreshed and asks the editor for
  // the current form content; `update` — the editor pushes the latest content.
  type: "update" | "reload";
  data?: PaymentReminderPreviewData | null;
}
